import { createSignal } from 'solid-js';

export enum PaymentMode {
  Portal = 'portal',
  Pay = 'pay',
}

export const [mode, setMode] = createSignal<PaymentMode>(PaymentMode.Portal);
